import React from 'react';
import './ColumnResizeHandle.css';

/**
 * Ручка у правого края ячейки шапки: тянуть мышью — менять ширину столбца,
 * двойной щелчок — вернуть исходную раскладку. Логика и хранение — в
 * useResizableColumns. <th> должен быть позиционирован (relative или sticky).
 *
 * Ручка скрыта от скринридеров: её подпись иначе вошла бы в имя заголовка
 * столбца («Зона Ширина столбца…»), а ширина — чисто визуальная настройка.
 */
const ColumnResizeHandle = ({ columnKey, resize }) => (
  <span
    className="col-resize-handle"
    aria-hidden="true"
    data-resize-handle={columnKey}
    title="Потяните, чтобы изменить ширину. Двойной щелчок вернёт исходную"
    onPointerDown={(event) => resize.startResize(columnKey, event)}
    onDoubleClick={resize.resetWidths}
    onClick={(event) => event.stopPropagation()}
  />
);

/**
 * Ячейка шапки для таблиц с рукописной шапкой. resizable={false} — столбец
 * без ручки (например, чекбокс выбора), но его ширина всё равно фиксируется.
 */
export const ResizableTh = ({ resize, colKey, label, className, resizable = true, children, ...rest }) => (
  <th
    {...rest}
    className={className ? `${className} col-resizable-th` : 'col-resizable-th'}
    data-col-key={colKey}
  >
    {children ?? label}
    {resizable && <ColumnResizeHandle columnKey={colKey} resize={resize} />}
  </th>
);

/** <colgroup> с заданными ширинами; без них — ничего, раскладка обычная. */
export const ResizableColgroup = ({ resize, keys }) => (resize.isResized ? (
  <colgroup>
    {keys.map((key) => <col key={key} style={{ width: resize.columnWidth(key) }} />)}
  </colgroup>
) : null);

export default ColumnResizeHandle;
